import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Mail, Phone, MapPin, Star, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { useSiteCopy } from "@/lib/copy";

export default function Footer() {
  const t = useSiteCopy();
  const [s, setS] = useState({});
  useEffect(() => { api.get("/settings/public").then(r => setS(r.data)).catch(()=>{}); }, []);

  const phone = s.contact_phone || "(423) 493-3600";
  const email = s.contact_email || "jcfitz79@hotmail.com";
  const address = s.address || "Service area on request";

  return (
    <footer className="relative mt-24 overflow-hidden water-gradient text-white">
      <div className="caustic-bg absolute inset-0 opacity-30" />
      <div className="relative mx-auto grid max-w-7xl gap-10 px-5 py-16 md:grid-cols-4 md:px-8">
        <div>
          <div className="font-display text-xl font-bold">Fix It Aquatics, LLC</div>
          <div className="mt-1 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-cyan-200">
            <Star className="h-3 w-3 fill-cyan-200" /> Veteran Owned & Operated
          </div>
          <p className="mt-4 max-w-xs text-sm text-cyan-100/90">
            {t("footer.tagline", "Crystal-clear pools, calm minds. Service, installation, retail and renovation — handled by craftspeople, finished like jewellery.")}
          </p>
          {s.netvendor_code && (
            <a
              href="https://www.netvendor.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1.5 text-xs font-medium text-white backdrop-blur transition hover:bg-white/20"
              data-testid="footer-netvendor-badge"
              title={`NetVendor verified contractor — code ${s.netvendor_code}`}
            >
              <ShieldCheck className="h-3.5 w-3.5 text-emerald-300" />
              NetVendor verified · {s.netvendor_code}
            </a>
          )}
        </div>
        <div>
          <div className="text-sm font-semibold uppercase tracking-widest text-cyan-200">Explore</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/services" className="text-white/85 hover:text-white">Services</Link></li>
            <li><Link to="/shop" className="text-white/85 hover:text-white">Shop</Link></li>
            <li><Link to="/quote" className="text-white/85 hover:text-white">Get a Quote</Link></li>
            <li><Link to="/about" className="text-white/85 hover:text-white">About</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold uppercase tracking-widest text-cyan-200">Account</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/login" className="text-white/85 hover:text-white">Sign in</Link></li>
            <li><Link to="/signup" className="text-white/85 hover:text-white">Create account</Link></li>
            <li><Link to="/contact" className="text-white/85 hover:text-white">Support</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold uppercase tracking-widest text-cyan-200">Contact</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><a href={`tel:${phone.replace(/[^\d+]/g, "")}`} className="flex items-center gap-2 text-white/85 hover:text-white"><Phone className="h-4 w-4 text-cyan-300" /> {phone}</a></li>
            <li><a href={`mailto:${email}`} className="flex items-center gap-2 text-white/85 hover:text-white"><Mail className="h-4 w-4 text-cyan-300" /> {email}</a></li>
            <li className="flex items-start gap-2 text-white/85"><MapPin className="mt-0.5 h-4 w-4 text-cyan-300" /> {address}</li>
          </ul>
        </div>
      </div>
      <div className="relative border-t border-white/10 py-5 text-center text-xs text-cyan-200">
        © {new Date().getFullYear()} Fix It Aquatics, LLC — built with care.
        <span className="mx-2 text-cyan-400/60">·</span>
        <a
          href="https://app.emergent.sh/?utm_source=emergent-badge"
          target="_blank"
          rel="noopener noreferrer"
          className="text-cyan-200 underline-offset-2 transition-colors hover:text-white hover:underline"
          data-testid="footer-emergent-link"
        >
          Made with Emergent
        </a>
      </div>
    </footer>
  );
}
